export default {
    'lang': 'zh-cn',
    'resetSettings': '还原设置',
    'include': '包含',
    'exclusive': '不包含',
    'equal': '等于',
    'unequal': '不等于',
    'begin': '以开始',
    'end': '以结尾',
    'greater_than': '大于',
    'great_than_equal_to': '大于等于',
    'less_than': '小于',
    'less_than_equal_to': '小于等于',
    'be_equal_to': '等于',
    'not_equal_to': '不等于',
    "no_data": '暂无数据',
    "bool_true": "是",
    "bool_false": "否",
    "total": "合计",
    'ok': '确定',
    'cancel': '取消',
    'show_row_num': '序号',
    'all': '全部',
    'search_no_row': '未搜索到匹配的行！',
    'already_first_row': '已经是匹配的第一行！',
    'already_last_row': '已经是匹配的最后一行！',
    'expand_all': '批量展开',
    'collapse_all': '批量收起',
    'overlay_up_text': '点击升序',
    'overlay_down_text': '点击降序',
    'cancel_overlay': '点击取消排序',
    'zh-cn': {
        'resetSettings': '还原设置',
        'include': '包含',
        'exclusive': '不包含',
        'equal': '等于',
        'unequal': '不等于',
        'begin': '以开始',
        'end': '以结尾',
        'greater_than': '大于',
        'great_than_equal_to': '大于等于',
        'less_than': '小于',
        'less_than_equal_to': '小于等于',
        'be_equal_to': '等于',
        'not_equal_to': '不等于',
        "no_data": '暂无数据',
        "bool_true": "是",
        "bool_false": "否",
        "total": "合计",
        'ok': '确定',
        'cancel': '取消',
        'show_row_num': '序号',
        'all': '全部',
        'search_no_row': '未搜索到匹配的行！',
        'already_first_row': '已经是匹配的第一行！',
        'already_last_row': '已经是匹配的最后一行！',
        'expand_all': '批量展开',
        'collapse_all': '批量收起',
        'overlay_up_text': '点击升序',
        'overlay_down_text': '点击降序',
        'cancel_overlay': '点击取消排序',
    },
    'en-us': {
        'resetSettings': 'Reset',
        'include': 'Include',
        'exclusive': 'Not include',
        'equal': 'Equal to',
        'unequal': 'Not equal to',
        'begin': 'Begin with',
        'end': 'End with',
        'greater_than': 'Greater than',
        'great_than_equal_to': 'Greater than or equal to',
        'less_than': 'Less than',
        'less_than_equal_to': 'Less than or equal to',
        'be_equal_to': 'Equal to',
        'not_equal_to': 'Not equal to',
        "no_data": 'No data',
        "bool_true": "true",
        "bool_false": "false",
        "total": "total",
        'ok': 'OK',
        'cancel': 'Cancel',
        'show_row_num': 'Serial number',
        'all': 'All',
        'search_no_row': 'No matching rows found!',
        'already_first_row': 'It is already the first matching line!',
        'already_last_row': 'It is already the last line of the match!',
        'expand_all': 'Batch expansion',
        'collapse_all': 'Bulk pack',
        'overlay_up_text': 'Click ascending',
        'overlay_down_text': 'Click descending',
        'cancel_overlay': 'Click Unsort',
    },
    'zh-tw': {
        'resetSettings': '還原設置',
        'include': '包含',
        'exclusive': '不包含',
        'equal': '等於',
        'unequal': '不等於',
        'begin': '以開始',
        'end': '以結尾',
        'greater_than': '大於',
        'great_than_equal_to': '大於等於',
        'less_than': '小於',
        'less_than_equal to': '小於等於',
        'be_equal_to': '等於',
        'not_equal_to': '不等於',
        "no_data": '暫無數據',
        "bool_true": "是",
        "bool_false": "否",
        "total": "合計",
        'cancel': '取消',
        'ok': '確定',
        'show_row_num': '序號',
        'all': '全部',
        'search_no_row': '未蒐索到匹配的行!',
        'already_first_row': '已經是匹配的第一行！',
        'already_last_row': '已經是匹配的最後一行！',
        'expand_all': '批量展開',
        'collapse_all': '批量收起',
        'overlay_up_text': '點擊升序',
        'overlay_down_text': '點擊降序',
        'cancel_overlay': '點擊取消排序',
    },
    'vi-vn': {
        'resetSettings': 'Thiết lập lại',
        'include': 'Có chứa',
        'exclusive': 'Không bao gồm',
        'equal': 'Có nghĩa là',
        'unequal': 'Không bằng',
        'begin': 'Để bắt đầu',
        'end': 'Để kết thúc',
        'greater_than': 'Lớn hơn',
        'great_than_equal_to': 'Lớn hơn hoặc bằng',
        'less_than': 'Nhỏ hơn',
        'less_than_equal_to': 'Ít hơn hoặc bằng',
        'be_equal_to': 'Có nghĩa là',
        'not_equal_to': 'Không bằng',
        "no_data": 'Không có dữ liệu',
        "bool_true": "là",
        "bool_false": "Nếu không",
        "total": "Tổng",
        'ok': 'Chắc chắn',
        'cancel': 'Hủy bỏ',
        'show_row_num': 'Số seri',
        'all': 'Tất cả',
        'search_no_row': 'Không tìm thấy dòng phù hợp!',
        'already_first_row': 'Đã là dòng đầu tiên của trận đấu!',
        'already_last_row': 'Đã là dòng cuối cùng của trận đấu!',
        'expand_all': 'Mở rộng hàng loạt',
        'collapse_all': 'Số lượng lớn',
        'overlay_up_text': 'Nhấp chuột lên',
        'overlay_down_text': 'Nhấp chuột xuống',
        'cancel_overlay': 'Nhấn vào để hủy bỏ việc sắp xếp',
    },
}
